import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

export default class CommandTriggerNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Execute Command';
        this.id = 'node_command_trigger';
        this.icon = 'HiCommandLine';
        this.linkedFeature = 'commands';

        this.inputs = [
            {
                name: 'Triggered',
                portId: 'command_trigger',
                params: [
                    {
                        name: 'data',
                        dataType: TibboDataType.STRING,
                        default: '',
                    },
                ],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'COMMAND',
                name: 'Command',
                settingType: SettingType.OPTION,
                refId: 'command',
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const project: ProjectConfiguration = this.project;
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const COMMAND = project.getFeature(this.getSettingValue('COMMAND'));
            if (COMMAND) {
                return `Trigger Command {{$${COMMAND.getSettingValue('NAME')}}}`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const COMMAND = project.getFeature(this.getSettingValue('COMMAND'));
        if (COMMAND) {
            return `Trigger Command {{$${COMMAND.getSettingValue('NAME')}}}`;
        }
        return this.name;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return 'Triggered when the **MD** button is pressed down.';
    }
}
